import { render, staticRenderFns } from "./DashboardCourseDetails.vue?vue&type=template&id=47b9e178&scoped=true&"
import script from "./DashboardCourseDetails.vue?vue&type=script&lang=js&"
export * from "./DashboardCourseDetails.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCourseDetails.vue?vue&type=style&index=0&id=47b9e178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9e178",
  null
  
)

/* custom blocks */
import block0 from "./DashboardCourseDetails.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports